import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-jobs-sidebar',
  templateUrl: './page-jobs-sidebar.component.html',
  styleUrls: ['./page-jobs-sidebar.component.css']
})
export class PageJobsSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
